import React, { useEffect } from 'react'
import PageTitle from '../../components/common/PageTitle'
import SertificateCard from '../../components/cards/SertificateCard'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useDispatch, useSelector } from 'react-redux';
import { getAbout } from '../../services/actions/MainAction';
function About() {
  const contentData = useSelector(state => state.Data.contentData);
  const aboutData = useSelector(state => state.Data.aboutData);
  const lang_id = useSelector(state => state.Data.lang_id);
  const dispatch = useDispatch()

  useEffect(()=>{
      dispatch(getAbout(lang_id));
      window.scrollTo(0,0)
   },[lang_id])
  return (
    <main className=' min-h-[115vh]'>
      <PageTitle title={contentData?.nav_1} />
      <section className='mt-[30px]'>
        <div className='container'>
          <div dangerouslySetInnerHTML={{__html:aboutData?.translate?.description}}></div>
        </div>
      </section>
    </main>
  )
}

export default About
